<script setup lang="ts">
import { computed } from "vue";

import { cardActions } from "@/action/cardActions";
import ActionMenuDropdown from "@/components/ActionMenu/ActionMenuDropdown.vue";
import { cardKey } from "@/components/StickyNote/injectKeys";
import {
  isActionVisible,
  isStickyMovable,
} from "@/components/StickyNote/internal/ActionMenu/actions";
import { boardKey } from "@/components/board/injectKeys";
import { injectStrict } from "@/utils/vue";

import MoveSticky from "./MoveSticky.vue";

const card = injectStrict(cardKey);
const board = injectStrict(boardKey);

const isVisible = computed(() => {
  const isVisible = isActionVisible("move", card, board.value);
  const isMovable = isStickyMovable(card, board.value);

  return isVisible && isMovable;
});
</script>

<template>
  <ActionMenuDropdown v-if="isVisible" :action="cardActions.move">
    <MoveSticky />
  </ActionMenuDropdown>
</template>
